import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React from 'react';
import AppIconNpayOn from '../icons/AppIconNpayOn.js';
import IcDownload from '../icons/IcDownload.js';
import COLOR from '../../foundation/color.js';
import { FOOTER_CLICK_CODES } from '../../log/footer.js';
import style from './NpayDownloadButton.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, style);
var ICON_SIZE = {
  APP_ICON_NPAY_ON: {
    width: 32,
    height: 32
  },
  IC_DOWNLOAD: {
    width: 24,
    height: 24
  }
};
var NPAY_APP_STORE_LINK = {
  IOS: 'https://apps.apple.com/kr/app/%EB%84%A4%EC%9D%B4%EB%B2%84%ED%8E%98%EC%9D%B4/id1554807824',
  ANDROID: 'https://play.google.com/store/apps/details?id=com.naverfin.payapp&hl=ko&gl=US'
};
function NpayDownloadButton(_ref) {
  var npayDownloadButtonProps = _ref.npayDownloadButtonProps;
  var isIOS = npayDownloadButtonProps.isIOS,
    isAndroid = npayDownloadButtonProps.isAndroid;
  var handleClickDownloadButton = function handleClickDownloadButton() {
    if (isIOS) {
      window.location.href = NPAY_APP_STORE_LINK.IOS;
      return;
    }
    if (isAndroid) {
      window.location.href = NPAY_APP_STORE_LINK.ANDROID;
      return;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article')
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('button'),
    onClick: handleClickDownloadButton,
    "data-nclicks": FOOTER_CLICK_CODES.NpayDownloadButton
  }, /*#__PURE__*/React.createElement("span", {
    className: cx('icon', 'app')
  }, /*#__PURE__*/React.createElement(AppIconNpayOn, {
    width: ICON_SIZE.APP_ICON_NPAY_ON.width,
    height: ICON_SIZE.APP_ICON_NPAY_ON.height
  })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: cx('point')
  }, "\uB124\uC774\uBC84\uD398\uC774 \uC571"), " \uB2E4\uC6B4\uB85C\uB4DC"), /*#__PURE__*/React.createElement("span", {
    className: cx('icon', 'download')
  }, /*#__PURE__*/React.createElement(IcDownload, {
    width: ICON_SIZE.IC_DOWNLOAD.width,
    height: ICON_SIZE.IC_DOWNLOAD.height,
    fill: COLOR.gray700.color
  }))));
}

export { NpayDownloadButton as default };
